/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const union = (...arrays) => {
	return arrays.reduce((acc, curr) => {
		acc.push(...curr);
		return acc;
	}, []);
};

export default union;


// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/util/union.js